<script>
export default {
  props: {
    grazing: { type: Object, required: true },
  },
}
</script>

<template>
  <b-card>
    GRAZING: {{grazing}}
  </b-card>
</template>



// WEBPACK FOOTER //
// src/grazing/components/Grazing.vue